<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="columns">
          <div v-if="!detail" class="column is-narrow">
            <selecteur-action
              :options="[]"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :elementsSelectionnes="false"
              titleButton="general.button.apply">
            </selecteur-action>
          </div>
          <form
            @submit.prevent="criteresRecherche.auto = search"
            :class="{'is-4': !detail}"
            class="column pdr-0">
            <b-input
              v-model="search"
              :placeholder="$t('general.autocomplete.search')"
              type="search" icon="magnify">
            </b-input>
          </form>
        </div>
      </div>
      <div class="level-right">
        <b-field v-if="!detail">
          <div class="no-border-radius-right">
            <button
              @click="goToEcranAddFaces()"
              class="button is-addOrEdit level-right">
              {{ $t('addEditRegroupementProduit.produits.addProduct') }}
            </button>
          </div>
        </b-field>
      </div>
    </div>
    <v-client-table
      :data="produitsFilter"
      :columns="columns"
      :options="options"
      ref="tableProduits">
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox
          v-model="props.row.selected"
          :value="props.row"
          @input="selectAll()">
        </b-checkbox>
      </div>
      <div slot="reference" slot-scope="props">
        <router-link-blank
          :to="{
            name: getLibelleAndRoutesForProduct(props.row).routeDetail,
            params: {id: props.row.id}
          }"
          :message="props.row.reference"
          :class="{'text-access-no-permission':
            !checkPermissions(permCatalogue.lecture)}"
          class="lien">
        </router-link-blank>
      </div>
      <div slot="type" slot-scope="props">
        <div>{{ $t(getLibelleAndRoutesForProduct(props.row).libelle) }}</div>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ getLibelleActif(props.row.actif) }}</div>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteProduct(props.row.id)">
          <b-icon icon="delete-forever" class="mgt-5px" type="is-danger"/>
        </a>
      </div>
      <template slot='afterTable'>
        <table-items-in-view @input='$refs.tableProduits.setLimit($event)' />
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import selecteurAction from '@/components/general/selecteurAction';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import { columnsSplice } from '@/services/general/columns';
import { SET_PRODUITS, SET_REGROUPEMENT_PRODUIT } from '@/store/modules/bodac/catalogue/regroupementProduit-mutation-type';

const Permissions = createNamespacedHelpers('permissions');
const RegroupementProduit = createNamespacedHelpers('regroupementProduit');

export default {
  name: 'ProduitsIndex',
  props: {
    regroupementProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
    breadcrumb: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  components: {
    TableItemsInView,
    routerLinkBlank,
    selecteurAction,
  },
  data() {
    return {
      search: '',
      permCatalogue: CATALOGUE,
      criteresRecherche: {
        auto: '',
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...RegroupementProduit.mapGetters({
      produitsRegroupement: 'produits',
    }),
    produitsFilter() {
      return this.regroupementProduit.produits.filter(item => {
        let search = false;
        [
          item.reference,
          item.libelle,
        ].forEach((itemSearch) => {
          if (itemSearch && itemSearch.toLowerCase()
            .includes(this.criteresRecherche.auto.toLowerCase())) {
            search = true;
          }
        });

        return search;
      });
    },
    iconSelectTotal() {
      if (this.allItemsSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allItemsSelected() {
      return this.getAllSelected().length === this.produitsFilter.length
        && this.produitsFilter.length > 0;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('addEditRegroupementProduit.produits.tab.reference'),
          type: this.$i18n.t('addEditRegroupementProduit.produits.tab.type'),
          libelle: this.$i18n.t('addEditRegroupementProduit.produits.tab.label'),
          actif: this.$i18n.t('addEditRegroupementProduit.produits.tab.actif'),
          delete: '',
          selected: (h) => {
            return h(
              'a',
              {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: ['reference', 'libelle', 'type', 'actif'],
        columnsClasses: {
          selected: 'colonneSelected',
          delete: 'colonneSelected',
        },
      };
    },
    columns() {
      const columns = ['selected', 'reference', 'type', 'libelle', 'actif', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...RegroupementProduit.mapMutations({
      setProduitsRegroupement: SET_PRODUITS,
      setRegroupementProduit: SET_REGROUPEMENT_PRODUIT,
    }),
    getAllSelected() {
      return this.produitsFilter.filter((el) => el.selected);
    },
    selectAll() {
      const state = !this.allItemsSelected;
      this.produitsFilter.forEach(item => {
        item.selected = state;
      });
    },
    getLibelleAndRoutesForProduct(produit) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find((c) => {
        return c.code === produit.supportCommercial.categorieVente;
      });
      if (!produitConfiguration) return '';
      if (produitConfiguration.code !== produitConf.CATEGORIE_LOCATION) return produitConfiguration;
      return produit.numerique ? produitConfiguration.numerique : produitConfiguration.nonNumerique;
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    deleteProduct(produitId) {
      const index = this.regroupementProduit.produits.findIndex(el => el.id === produitId);
      if (index !== -1) {
        this.regroupementProduit.produits.splice(index, 1);
      }
    },
    goToEcranAddFaces() {
      this.setRegroupementProduit(this.regroupementProduit);
      this.setProduitsRegroupement(this.regroupementProduit.produits);
      this.$router.push({
        name: 'm.bodac.catalogue-ajoutProduitsSurRegroupement',
        params: { breadcrumb: this.breadcrumb },
      });
    },
  },
  mounted() {
    if (this.produitsRegroupement) {
      this.regroupementProduit.produits = this.produitsRegroupement;
      this.setProduitsRegroupement(null);
    }
  },
};
</script>
